import eventMixin from '../lib/eventMixin';
import Logger from '../utilities/Logger';
import ThemeMediaPanel from './themeMediaPanel';

export default class ThemeBlockThreePanelBanner {

	constructor(dom) {

		Logger.info('ThemeBlockThreePanelBanner: initializing...');

		var self = this;

		this.dom = dom;

		// Gather all ThemeMediaPanel's
		const themeMediaPanels = this.dom.querySelectorAll('[data-theme-media-panel]');
		themeMediaPanels.forEach((dom) => {
			const panel = new ThemeMediaPanel(dom);
		});

	}

}

// Mixins
Object.assign(ThemeBlockThreePanelBanner.prototype, eventMixin);
